export const MEDIA_WRAPPER_CONTENTFUL_TYPE = 'MediaWrapperV2'
export const TEXT_AND_BUTTON_CONTENTFUL_TYPE = 'TextAndButtonBanner'
export const BOOKING_TOOL_LABEL_MEDIUM = 'bt_panel'
export const BOOKING_TOOL_LINK_TYPE_LABEL = 'Booking Tool'
